import React from 'react';
import { SiteLink } from 'components';
import { LoginStatus } from 'auth';

export function AppHeader() {
  return (
    <div className="appHeader">
      <div className="appHeader__logo">
        <SiteLink to="/">
        <img src="/admin/assets/logos/logo.png" alt="logo" />
        </SiteLink>
      </div>
     <LoginStatus/>
    </div>
  );
}
